import React from "react";

/**
 * Real Studio Brehaut logo (sourced from peiarchitect.com).
 * The logo already has its own olive-green plate so it reads on both
 * dark navy and linen backgrounds.
 */
export const Logo = ({ className = "", size = "md" }) => {
  const scrollTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const h = size === "lg" ? "h-10 md:h-12" : size === "sm" ? "h-7 md:h-8" : "h-8 md:h-9";

  return (
    <a
      href="#top"
      onClick={scrollTop}
      aria-label="studio Brehaut architecture — home"
      data-testid="brand-logo"
      className={`inline-flex items-center group ${className}`}
    >
      <img
        src={`${process.env.PUBLIC_URL}/images/sba-logo.jpg`}
        alt="studio Brehaut architecture"
        className={`${h} w-auto select-none`}
        draggable="false"
        decoding="async"
      />
    </a>
  );
};

export default Logo;
